/* eslint-disable linebreak-style */
/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CREATE_PAY_ADMIN = gql`
  mutation createPayAdminAccount($input: CreateAdminIn) {
    createPayAdminAccount(input: $input) {
      status
    }
  }
`;

export const SEARCH_PAY_ADMIN = gql`
  query {
    adminAccount {
      email
      role
      _id
      fname
      lname
      mobile
      status
      created_at
      updated_at
    }
  }
`;

export const GET_SCRIPT = gql`
  query GetRunScript($script_name: String) {
    getRunScript(script_name: $script_name) {
      title
      status
      link
    }
  }
`;
export const GET_SCRIPT_DETAILS = gql`
  query {
    getRunScriptCouseIncomeStudents {
      title
      status
      link
    }
  }
`;

export const GET_ADMIN_PAYMENT_DETAILS = gql`
  query {
    getRunScriptAdminPayments {
      title
      status
      link
    }
  }
`;
export const GET_ADMIN_PAYMENT_BANK = gql`
  query {
    getRunScriptPaymentBankAccounts {
      title
      status
      link
      created_at
    }
  }
`;
export const GET_RUN_SCRIPT_COMMISSION_REPORT = gql`
  query {
    getRunScriptCommissionReport {
      title
      status
      link
      created_at
    }
  }
`;
export const GET_CURRIER_SCRIPT_DETAILS = gql`
  query {
    getRunScriptCurrierReport {
      title
      status
      link
      key
      pdfLink
      courierExcel
    }
  }
`;
export const CHANGE_PASSWORD_BY_PVS = gql`
  mutation changePasswordByPvs($input: changePasswordByPvsIn) {
    changePasswordByPvs(input: $input) {
      status
    }
  }
`;
export const GET_RUN_SCRIPT_CREATE_PAYMENT_RECORDS = gql`
  query {
    getRunScriptCraetePaymentRecords {
      title
      status
      link
      logFile
      created_at
    }
  }
`;

export const SEND_OTP = gql`
  mutation SendOtp($input: createStudentOTpSendIn) {
    createStudentOTpSend(input: $input) {
      status
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation VerifyOtp($input: createStudentOTpVerifyIn) {
    createStudentOTpVerify(input: $input) {
      mobileVerifedToken
    }
  }
`;

export const GET_RUN_SCRIPT_COURSE_PAID_STUDENT = gql`
  query {
    getRunScriptCousePaidStudentsReport {
      title
      status
      link
      key
      pdfLink
      start
      end
      created_at
    }
  }
`;

export const GET_RUN_SCRIPT_STUDENTS_DETAILS_REPORT = gql`
  query getRunScriptStudentsDetailsReport {
    getRunScriptStudentsDetailsReport {
      title
      status
      link
      created_at
    }
  }
`;

export const GET_LESSON_WATCH_TIME_REPORT = gql`
  query {
    getRunScriptLessonWatchTimeReport {
      title
      status
      link
      key
      created_at
    }
  }
`;

export const SEARCH_ADMINS = gql`
  query searchAdminAccounts($filters: AccountSearchIn) {
    searchAdminAccounts(input: $filters) {
      limit
      skip
      resultCount
      result {
        _id
        fname
        lname
        email
        role
        actions
        otp_enabled
        otp_login_disabled
        status
        created_at
        updated_at
      }
    }
  }
`;

export const GET_ADMIN_ACCOUNT = gql`
  query getAdminAccount($accountId: String!) {
    getAdminAccount(accountId: $accountId) {
      account {
        _id
        fname
        lname
        email
        status
        role
        actions
        otp_enabled
        otp_login_disabled
        created_at
        updated_at
      }
    }
  }
`;

export const GET_ROLES_AND_ACCOUNT_ACTIONS = gql`
  query getRolesAndAccountActions {
    getRolesAndAccountActions {
      roles
      actions {
        group
        actions {
          action
          label
          roles
        }
      }
    }
  }
`;

export const CREATE_ADMIN_ACCOUNT = gql`
  mutation CreateAdminAccount($input: AdminAccountIn) {
    createAdminAccount(input: $input) {
      status
    }
  }
`;

export const UPDATE_ADMIN_ACCOUNT = gql`
  mutation UpdateAdminAccount($input: AdminAccountIn) {
    updateAdminAccount(input: $input) {
      status
    }
  }
`;

export const SEND_ADMIN_OTP = gql`
  mutation SendAdminOtp($challengeToken: String!) {
    sendAdminOtp(challengeToken: $challengeToken) { status maskedMobile }
  }
`;

export const SETUP_ADMIN_OTP = gql`
  mutation SetupAdminOtp($challengeToken: String!, $mobile: String!) {
    setupAdminOtp(challengeToken: $challengeToken, mobile: $mobile) {
      status backupCodes maskedMobile
    }
  }
`;

export const VERIFY_ADMIN_OTP = gql`
  mutation VerifyAdminOtp($challengeToken: String!, $code: String!) {
    verifyAdminOtp(challengeToken: $challengeToken, code: $code) {
      success accessToken userAccount { _id fname lname email role status otp_enabled otp_login_disabled created_at updated_at }
    }
  }
`;

export const VERIFY_ADMIN_BACKUP_CODE = gql`
  mutation VerifyAdminBackupCode($challengeToken: String!, $backupCode: String!) {
    verifyAdminBackupCode(challengeToken: $challengeToken, backupCode: $backupCode) {
      success accessToken remainingBackupCodes
      userAccount { _id fname lname email role status otp_enabled otp_login_disabled created_at updated_at }
    }
  }
`;

export const USE_ADMIN_OTP_BYPASS = gql`
  mutation UseAdminOtpBypass($challengeToken: String!, $bypassToken: String!) {
    useAdminOtpBypass(challengeToken: $challengeToken, bypassToken: $bypassToken) {
      success accessToken userAccount { _id fname lname email role status otp_enabled otp_login_disabled created_at updated_at }
    }
  }
`;

export const REGENERATE_ADMIN_BACKUP_CODES = gql`
  mutation RegenerateAdminBackupCodes { regenerateAdminBackupCodes { backupCodes } }
`;

export const GET_ACTIVE_ADMIN_OTP_BYPASS = gql`
  query GetActiveAdminOtpBypass($targetAccountId: String!) {
    getActiveAdminOtpBypass(targetAccountId: $targetAccountId) {
      exists bypassToken maskedToken expiresAt isRevoked isExpired
    }
  }
`;

export const ISSUE_ADMIN_OTP_BYPASS = gql`
  mutation IssueAdminOtpBypass($targetAccountId: String!, $expiresInMinutes: Int) {
    issueAdminOtpBypass(targetAccountId: $targetAccountId, expiresInMinutes: $expiresInMinutes) {
      bypassToken maskedToken expiresAt expiresInMinutes
    }
  }
`;

export const REVOKE_ADMIN_OTP_BYPASS = gql`
  mutation RevokeAdminOtpBypass($targetAccountId: String!, $bypassToken: String!) {
    revokeAdminOtpBypass(targetAccountId: $targetAccountId, bypassToken: $bypassToken) { success }
  }
`;

export const RESET_ADMIN_OTP = gql`
  mutation ResetAdminOtp($targetAccountId: String!) {
    resetAdminOtp(targetAccountId: $targetAccountId) { success }
  }
`;

export const SET_OTP_LOGIN_DISABLED = gql`
  mutation SetOtpLoginDisabled($targetAccountId: String!, $disabled: Boolean!) {
    setOtpLoginDisabled(targetAccountId: $targetAccountId, disabled: $disabled) {
      success otp_login_disabled
    }
  }
`;

export const LOGOUT_ADMIN_FROM_ALL_SESSIONS = gql`
  mutation LogoutAdminFromAllSessions($targetAccountId: String!) {
    logoutAdminFromAllSessions(targetAccountId: $targetAccountId) { success }
  }
`;
